const prefix = '[send-to-partners] ';

export const UPDATE_PROPS = 'UPDATE_PROPS_IN_SEND_TO_PARTNERS_REDUCER';
export const LOADING_EXISTING_CONNECTIONS = 'LOADING_EXISTING_CONNECTIONS_IN_SEND_TO_PARTNERS_REDUCER';
export const GOT_EXISTING_CONNECTIONS = 'GOT_EXISTING_CONNECTIONS_IN_SEND_TO_PARTNERS_REDUCER';
export const CHECK_CONNECTION = 'CHECK_CONNECTION_IN_SEND_TO_PARTNERS_REDUCER';
export const UNCHECK_CONNECTION = 'UNCHECK_CONNECTION_IN_SEND_TO_PARTNERS_REDUCER';
export const PROCESSING_PARTNERS = 'PROCESSING_PARTNERS_IN_SEND_TO_PARTNERS_REDUCER';
export const PARTNERS_PROCESSED = 'PARTNERS_PROCESSED_IN_SEND_TO_PARTNERS_REDUCER';
export const CLEAR_STORE = 'CLEAR_STORE_IN_SEND_TO_PARTNERS_REDUCER';
export const GOT_CONTRACTING_PARTNERS = 'GOT_CONTRACTING_PARTNERS_IN_SEND_TO_PARTNERS_REDUCER';
export const GOT_REQUESTS = 'GOT_MATCHED_REQUESTS_FOR_SUPPLIER_SENDING_RATES';



// WEBPACK FOOTER //
// ./src/app/stores/contracting/send-to-partners/constants.js